import { React, useEffect, useState } from "react";
import CustomInput from "../../components/CustomInput";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  createMenu,
  getAMenu,
  resetState,
  updateAMenu,
} from "../../features/cms/menus/cmsMenusSlice";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";

let schema = yup.object().shape({
  name: yup.string().required("Menu Name is Required"),
  location: yup.string().required("Location is Required"),
});

const AddMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getMenuId = location.pathname.split("/")[4];
  const menuState = useSelector((state) => state.cmsMenus);

  const {
    isSuccess,
    isError,
    isLoading,
    createdMenu,
    menuName,
    menuLocation,
    menuIsActive,
    menuItems,
    updatedMenu,
  } = menuState;

  const [items, setItems] = useState([]);

  useEffect(() => {
    if (getMenuId !== undefined) {
      dispatch(getAMenu(getMenuId));
    } else {
      dispatch(resetState());
      setItems([
        {
          label: "",
          url: "",
          target: "_self",
          icon: "",
          order: 1,
          children: [],
        },
      ]);
    }
  }, [getMenuId, dispatch]);

  useEffect(() => {
    if (menuItems && menuItems.length > 0) {
      setItems(menuItems);
    }
  }, [menuItems]);

  useEffect(() => {
    if (isSuccess && createdMenu) {
      toast.success("Menu Added Successfully!");
      navigate("/admin/cms/menus");
    }
    if (isSuccess && updatedMenu) {
      toast.success("Menu Updated Successfully!");
      navigate("/admin/cms/menus");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, navigate]);

  const addMenuItem = () => {
    setItems([
      ...items,
      {
        label: "",
        url: "",
        target: "_self",
        icon: "",
        order: items.length + 1,
        children: [],
      },
    ]);
  };

  const removeMenuItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
  };

  const updateMenuItem = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;
    setItems(newItems);
  };

  const addChildItem = (parentIndex) => {
    const newItems = [...items];
    if (!newItems[parentIndex].children) {
      newItems[parentIndex].children = [];
    }
    newItems[parentIndex].children.push({
      label: "",
      url: "",
      target: "_self",
      icon: "",
    });
    setItems(newItems);
  };

  const removeChildItem = (parentIndex, childIndex) => {
    const newItems = [...items];
    newItems[parentIndex].children = newItems[parentIndex].children.filter(
      (_, i) => i !== childIndex
    );
    setItems(newItems);
  };

  const updateChildItem = (parentIndex, childIndex, field, value) => {
    const newItems = [...items];
    newItems[parentIndex].children[childIndex][field] = value;
    setItems(newItems);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: menuName || "",
      location: menuLocation || "",
      isActive: menuIsActive !== undefined ? menuIsActive : true,
      items: items,
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const menuData = {
        ...values,
        items: items,
      };
      if (getMenuId !== undefined) {
        dispatch(updateAMenu({ id: getMenuId, menuData }));
        dispatch(resetState());
      } else {
        dispatch(createMenu(menuData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  useEffect(() => {
    formik.setFieldValue("items", items);
  }, [items]);

  return (
    <div>
      <h3 className="mb-4 title">
        {getMenuId !== undefined ? "Edit" : "Add"} Menu
      </h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Menu Name"
              name="name"
              onChng={formik.handleChange("name")}
              onBlr={formik.handleBlur("name")}
              val={formik.values.name}
            />
          </div>
          <div className="error">
            {formik.touched.name && formik.errors.name}
          </div>

          <div className="mt-3">
            <label className="mb-2">Location</label>
            <select
              name="location"
              onChange={formik.handleChange("location")}
              onBlur={formik.handleBlur("location")}
              value={formik.values.location}
              className="form-control py-3"
            >
              <option value="">Select Location</option>
              <option value="header">Header</option>
              <option value="footer">Footer</option>
              <option value="sidebar">Sidebar</option>
              <option value="mobile">Mobile</option>
            </select>
          </div>
          <div className="error">
            {formik.touched.location && formik.errors.location}
          </div>

          <div className="mt-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="isActive"
                checked={formik.values.isActive}
                onChange={(e) =>
                  formik.setFieldValue("isActive", e.target.checked)
                }
              />
              <label className="form-check-label" htmlFor="isActive">
                Active
              </label>
            </div>
          </div>

          <div className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Menu Items</h5>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={addMenuItem}
              >
                <AiOutlinePlus /> Add Item
              </button>
            </div>

            {items.map((item, index) => (
              <div key={index} className="card mb-3 p-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6>Item {index + 1}</h6>
                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    onClick={() => removeMenuItem(index)}
                  >
                    <AiOutlineMinus /> Remove
                  </button>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-2">
                    <CustomInput
                      type="text"
                      label="Label"
                      value={item.label}
                      onChng={(e) =>
                        updateMenuItem(index, "label", e.target.value)
                      }
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <CustomInput
                      type="text"
                      label="URL"
                      value={item.url}
                      onChng={(e) =>
                        updateMenuItem(index, "url", e.target.value)
                      }
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="mb-2">Target</label>
                    <select
                      className="form-control"
                      value={item.target}
                      onChange={(e) =>
                        updateMenuItem(index, "target", e.target.value)
                      }
                    >
                      <option value="_self">Same Window</option>
                      <option value="_blank">New Window</option>
                    </select>
                  </div>
                  <div className="col-md-6 mb-2">
                    <CustomInput
                      type="text"
                      label="Icon (optional)"
                      value={item.icon}
                      onChng={(e) =>
                        updateMenuItem(index, "icon", e.target.value)
                      }
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <CustomInput
                      type="number"
                      label="Order"
                      value={item.order}
                      onChng={(e) =>
                        updateMenuItem(index, "order", parseInt(e.target.value))
                      }
                    />
                  </div>
                </div>

                <div className="mt-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6>Sub Items</h6>
                    <button
                      type="button"
                      className="btn btn-sm btn-secondary"
                      onClick={() => addChildItem(index)}
                    >
                      <AiOutlinePlus /> Add Sub Item
                    </button>
                  </div>

                  {item.children &&
                    item.children.map((child, childIndex) => (
                      <div key={childIndex} className="card p-2 mb-2">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span>Sub Item {childIndex + 1}</span>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => removeChildItem(index, childIndex)}
                          >
                            <AiOutlineMinus />
                          </button>
                        </div>
                        <div className="row">
                          <div className="col-md-4 mb-2">
                            <CustomInput
                              type="text"
                              label="Label"
                              value={child.label}
                              onChng={(e) =>
                                updateChildItem(
                                  index,
                                  childIndex,
                                  "label",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="col-md-4 mb-2">
                            <CustomInput
                              type="text"
                              label="URL"
                              value={child.url}
                              onChng={(e) =>
                                updateChildItem(
                                  index,
                                  childIndex,
                                  "url",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="mb-2">Target</label>
                            <select
                              className="form-control"
                              value={child.target}
                              onChange={(e) =>
                                updateChildItem(
                                  index,
                                  childIndex,
                                  "target",
                                  e.target.value
                                )
                              }
                            >
                              <option value="_self">Same Window</option>
                              <option value="_blank">New Window</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </div>

          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getMenuId !== undefined ? "Update" : "Add"} Menu
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddMenu;

